




















































































import { StoreActions } from '@/store';
import { Component, Provide, Vue } from 'vue-property-decorator';
import MemberFilters from '@/components/members/MemberFilters.vue';
import {
  createMemberSpecification,
  Member,
  MemberFilterSettings,
} from '@/model/member.model';
import { Family } from '@/model/family.model';

@Component({
  components: {
    MemberFilters,
  },
})
export default class Members extends Vue {
  @Provide() filters: MemberFilterSettings = {};

  get members() {
    const memberSpec = createMemberSpecification(this.filters);
    return this.$store.state.members.filter(memberSpec);
  }

  get hasNewRegistrations(): boolean {
    return this.$store.state.families.some((f: Family) => f.pending);
  }

  created() {
    this.$store.dispatch(StoreActions.GetMembers);
  }

  async approve(member: Member) {
    const family: Family = this.$store.state.families.find(
      (f: Family) => f.key === member.key,
    );
    await this.$store.dispatch(StoreActions.ApproveSignup, family);
    if (!this.hasNewRegistrations) {
      this.updateFilters({
        search: this.filters.search,
        year: this.filters.year,
      });
    }
    this.$store.dispatch(StoreActions.GetMembers);
  }

  removeMembers() {
    this.$store.commit('ms/openModal', {
      modal: 'member-removal-modal',
      data: {
        // confirm: this.onConfirmDeleteProject,
      },
    });
  }

  newFamily() {
    this.$router.push('/new-family');
  }

  updateFilters(filters: MemberFilterSettings) {
    this.filters = filters;
  }
}
